<template>
  <div class="menu">
    <!-- Nav -->
    <nav id="nav">
      <div id="logo">
          <router-link to="/"><img src="../assets/logo.png" width="35" height="35"/></router-link>
      </div>
      <ul>
        <li v-for="item in menuItems" :class="{current:item.id == menutItemSelected, item} " @click="menutItemSelected = item.id" :key="item.id">
          <router-link :to="item.link">{{ $t(item.name) }}</router-link>
        </li>
      </ul>
    </nav>
    <div class="menu-responsive">
      <a href="#"><i class="fas fa-bars" @click="showResponsiveMenu"></i></a>
    </div>
    <div class="responsive-panel" v-bind:class="{inactive: showMenuMobile==false}">
      <div class="responsive-panel__header">
        <div class="responsive-panel__header-social"></div>
        <div class="responsive-panel__header-close">
          <a href="#" class="responsive-panel__header-close-button" @click="closeResponsiveMenu">
            <i class="icon solid fa-times"></i>
          </a>
        </div>
      </div>
      <div class="responsive-panel__body">
        <ul class="responsive-panel__container">
          <li v-for="item in menuItems" :class="{current:item.id == menutItemSelected, item} " @click="closeResponsiveMenu" :key="item.id">
            <router-link  :to="item.link">{{ $t(item.name) }} <i class="icon solid fa-chevron-right"></i></router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data: () => ({
    menutItemSelected: 1,
    showMenuMobile: false,
    menuItems: [
      {
        id: 1,
        link: '/',
        name: 'index'
      },
      {
        id: 2,
        link: '/nosotros',
        name: 'about_us'
      },
      {
        id: 3,
        link: '/servicios',
        name: 'services'
      },
      {
        id: 4,
        link: '/conocenos',
        name: 'know_us'
      },
      {
        id: 5,
        link: '/contacto',
        name: 'contact'
      }
    ]
  }),
  methods: {
    closeResponsiveMenu () {
      this.showMenuMobile = false
    },
    showResponsiveMenu () {
      this.showMenuMobile = true
    }
  }
}
</script>

<style lang='less' scoped>

    #nav ul {
        float: left;
    }

    #nav li>ul {
        position: absolute;
    }
    #nav li>ul>li>a {
        border-radius: 6px;
    }

    #nav > ul > li > a:hover + ul {
        display: block;
        margin-top: 0em;
    }

    #logo {
        display: block;
        float: left;
        width: 100px;
        margin-left: 20%;
    }

    #logo img {
        vertical-align: middle;
        position: relative;
        left: 50%;
    }

    .inactive, .menu-responsive {
      display: none;
    }
  @media only screen and ( max-width: 980px ) {
    .menu {
      width: 100vw;
      display: block;
      height: 50px;
      background: #38477F;
      position: fixed;
      z-index: 3;
    }
    .menu-responsive {
      display: inline-block;
      vertical-align: top;
      position: absolute;
      top: 0;
      left: 20px;
      top: -5px;
      i {
        width: 64px;
        height: 54px;
        font-size: 27px;
        line-height: 54px;
        display: inline-block;
        padding-top: 1px;
        color: #000;
      }
    }

    .responsive-panel {
      padding: 0;
      position: absolute;
      width: 100vw;
      height: 100vh;
      top: 0;
      z-index: 9999;
      background-color: #38477F;
      opacity: 0.8;
      &__header-social {
        padding: 0 65px 0 20px;
        overflow: hidden;
        height: 60px;
      }

      &__header-close {
        position: absolute;
        right: 1px;
        top: 0;
        z-index: 1000;
        width: 70px;
        & i.icon {
          height: 70px;
          width: 70px;
          line-height: 70px;
          font-size: 21px;
          color: #fff;
          top: 4px;
          position: relative;
        }
      }
      &__container {
        padding: 20px 20px 0;
        & li {
          list-style-type: none;
          & a {
            color: #FFF;
            text-transform: uppercase;
            text-decoration: none;
            display: block;
            line-height: 21px;
            font-size: 18px;
            margin-left: 0;
            padding: 12px 30px 12px 12px;
            font-weight: 700;
          }
          & i.icon {
            position: relative;
            cursor: pointer;
            top: -5px;
            right: -4px;
            z-index: 1000;
            font-size: 14px;
            padding: 6px 12px;
            float: right;
            color: #fff;
            -webkit-transform-origin: 50% 48% 0;
            -moz-transform-origin: 50% 48% 0;
            -o-transform-origin: 50% 48% 0;
            transform-origin: 50% 48% 0;
            &:before {
              color: #FFF;
            }
          }
        }
      }
    }
  }
</style>
